import React from 'react';
import './ErrorView.scss';

interface ErrorViewProps {
    error: string | null;
}

export const ErrorView: React.FC<ErrorViewProps> = ({ error }) => {
    return (
        <div className="TopikTest">
            <div className="ErrorView">
                <h3>{"Error"}</h3>
                <p>{error || "Failed to load test"}</p>
            </div>
        </div>
    );
};